import { FC } from "react";
import { Spin } from "antd";

export const CustomFormQrCodeLoading: FC = () => {
  return <Spin />;
};
